import { useMemo } from 'react'
import { extractErrorMessage } from '@/api/helpers/extractErrorMessage'
import { useCheckIntegrationUrl } from '@/queries/cameraQueries'

export type ConnectionStatus = 'ok' | 'error' | 'pending' | null

export const useTestConnectionStatus = () => {
  const { data, mutate, isPending, isError, error } = useCheckIntegrationUrl()

  const status: ConnectionStatus = useMemo(() => {
    if (isPending) {
      return 'pending'
    }

    if (isError) {
      return 'error'
    }

    if (data) {
      return data.success ? 'ok' : 'error'
    }

    return null
  }, [isPending, isError, data])

  return {
    checkConnection: mutate,
    status,
    errorMessage: error
      ? extractErrorMessage(error, undefined, {
          // When checking connectivity, a validation error is returned if there's a connection issue. By default, validation error messages include the field name, but we don't want that here.
          includeFieldNameInValidationErrors: false
        })
      : undefined
  }
}
